import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Heart, Loader2 } from "lucide-react";
import customerApi from "./customerApi";

const STEPS = ["received", "checking", "rooting", "match", "ready"];

export default function HQCrushes() {
  const [rows, setRows] = useState(null);
  useEffect(() => { customerApi.get("/customer/crush/requests").then((r) => setRows(r.data || [])).catch(() => setRows([])); }, []);

  return (
    <div className="space-y-6" data-testid="hq-crushes">
      <div>
        <div className="text-[10px] tracking-[0.4em] uppercase font-semibold text-[#6E1E3A]">The Cutting Crush Club</div>
        <h1 className="font-serif text-3xl text-[#3C2A1E] mt-1">My Crushes ♡</h1>
        <p className="text-sm text-[#7A6A55] mt-1">Every cutting request you've sent, and where it's at. Requests are expressions of interest , we confirm availability and pricing before anything is charged.</p>
      </div>
      {rows === null ? <Loader2 className="w-5 h-5 animate-spin text-[#6E1E3A]" /> : rows.length === 0 ? (
        <div className="bg-white border border-[#E8DFCB] rounded-2xl p-8 text-center" data-testid="hq-crushes-empty">
          <Heart className="w-8 h-8 mx-auto text-[#6E1E3A]" />
          <p className="mt-3 text-[#3C2A1E]">No crushes yet. Go fall for something.</p>
          <Link to="/crush" className="inline-block mt-4 px-5 h-10 leading-10 rounded-full bg-[#6E1E3A] text-white text-[11px] tracking-[0.2em] uppercase font-bold" data-testid="hq-crushes-browse">Browse the collection</Link>
        </div>
      ) : rows.map((r) => <CrushCard key={r.id} r={r} />)}
    </div>
  );
}

function CrushCard({ r }) {
  const stepIdx = STEPS.indexOf(r.status);
  return (
    <article className="bg-white border border-[#E8DFCB] rounded-2xl p-5" data-testid={`hq-crush-${r.ref}`}>
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div>
          <div className="text-[10px] tracking-[0.3em] uppercase text-[#9C8B73]">{r.ref} · {new Date(r.created_at).toLocaleDateString("en-NZ")}</div>
          <div className="font-serif text-xl text-[#3E1F46] mt-1" data-testid={`hq-crush-status-${r.ref}`}>{r.label}</div>
          <p className="text-sm text-[#5c4a3b] mt-1 max-w-xl">{r.blurb}</p>
        </div>
        {r.order_ids?.length > 0 && <Link to="/account/orders" className="px-4 h-9 leading-9 rounded-full bg-[#2F6B4F] text-white text-[10px] tracking-[0.2em] uppercase font-bold" data-testid={`hq-crush-order-${r.ref}`}>View order</Link>}
      </div>
      {r.status !== "declined" && (
        <ol className="mt-4 grid grid-cols-5 gap-1" aria-label="Progress">
          {STEPS.map((s, i) => <li key={s} className={`h-1.5 rounded-full ${i <= stepIdx ? "bg-[#6E1E3A]" : "bg-[#F3EBDD]"}`} />)}
        </ol>
      )}
      <ul className="mt-4 flex flex-wrap gap-2">
        {r.items.map((i, idx) => (
          <li key={idx} className={`px-3 py-1.5 rounded-full text-xs border ${i.decision === "approved" ? "bg-[#E4F0E8] border-[#2F6B4F] text-[#2F6B4F]" : i.decision === "declined" ? "bg-[#FBF0F0] border-[#A33030] text-[#A33030] line-through" : "bg-[#FBF6E9] border-[#E8DFCB] text-[#3C2A1E]"}`} data-testid={`hq-crush-item-${r.ref}-${idx}`}>
            {i.qty}× {i.name}{i.customer_note ? ` , ${i.customer_note}` : ""}
          </li>
        ))}
      </ul>
    </article>
  );
}
